export default __webpack_public_path__ + "static/media/services_trans_2.8e09997e.jpg";